import type { Bike, BikeImage, BikeVariant } from "@/types/bike";

export const variantColor = (variant: BikeVariant) =>
  variant.selectedOptions?.find((option) => option.name === "Color")?.value;

export const availableVariants = (bike: Bike) => {
  const variants = bike.variants || [];
  const tracksInventory = variants.some((variant) => Number.isFinite(variant.inventoryQuantity));
  return tracksInventory
    ? variants.filter((variant) => (variant.inventoryQuantity || 0) > 0)
    : variants;
};

export const availableColors = (bike: Bike) =>
  [...new Set(availableVariants(bike).map(variantColor).filter((value): value is string => Boolean(value)))];

export interface AvailableVariantImage {
  image: BikeImage;
  color?: string;
}

export const availableVariantImages = (bike: Bike): AvailableVariantImage[] => {
  const seen = new Set<string>();
  return availableVariants(bike).flatMap((variant) => {
    const media = variant.media?.nodes?.find((item) => item.mediaContentType === "IMAGE" && item.image?.url);
    if (!media?.image?.url || seen.has(media.image.url)) return [];
    seen.add(media.image.url);
    return [{ image: media.image, color: variantColor(variant) }];
  });
};
